import React from 'react'

export default function LoadingPage() {
    return (
        <div className="loader-container">
            <div className="loader"></div>
        </div>
    )
}
